import { FieldPath, FieldValues } from 'react-hook-form';
import TeamSelectAutocomplete, { TeamSelectAutocompleteProps } from '@/components/TeamSelectAutocomplete';
import { getConfigFromStorage } from '@/utils/config';

export default function TeamFilterSelect<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>(props: TeamSelectAutocompleteProps<TFieldValues, TName>) {
  if (getConfigFromStorage()?.is_multi_team === false) return null;
  return <TeamSelectAutocomplete {...props} />;
}
